import Select from 'react-select'
import './ContentDropdown.css'

export const ContentDropdown = ({
    name,
    value,
    options,
    onChange,
}) => {
    
    return (
        <div>
            <Select
                className="content-editable__dropdown"
                classNamePrefix="ced"
                options={options}
                value={value}
                name={name}
                onChange={option => {
                    onChange(option.value)
                }} />
        </div>
    )
}
